import { atom, useAtomValue } from 'jotai';

import { UserDetailsWithPermissionDto, UserRoleDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export const UserDefaultValues: UserContextProps = {
  dataReady: false,
  email: '',
  enabled: false,
  externalUserId: '',
  firstName: '',
  lastLogin: '',
  lastName: '',
  permissions: [],
  role: UserRoleDto.EquipmentDepartment,
  userId: '',
  userSelectOption: { label: '', value: '' },
};

export type UserContextProps = UserDetailsWithPermissionDto & {
  dataReady: boolean;
  userSelectOption: SelectSearchOptionModel;
};

export const userAtom = atom<UserContextProps>(UserDefaultValues);

export const useUserContext = (): UserContextProps => {
  return useAtomValue<UserContextProps>(userAtom);
};
